<template>
	<IconButtonLayout class="ellipsis-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:class="iconClass"
				:icon="[ `far`, `ellipsis-h`]"
				@click="$emit( `open` )"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "EllipsisButton",
	emits: [ "open", ],
	components: {
		IconButtonLayout,
	},
};
</script>

<style lang="scss" scoped></style>
